<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Crear tipo de concepto de pago</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--6">
      <div class="row justify-content-center">
        <concept-payment-type-form @save="save" />
      </div>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import ConceptPaymentTypeForm from './Forms/ConceptPaymentTypeForm';
import swal from 'sweetalert2';

export default {
  name: 'ConceptPaymentTypeCreate',
  components: {
    ConceptPaymentTypeForm,
    RouteBreadCrumb,
  },

  methods: {
    save(conceptPaymentType) {
      this.$services
        .resource('concept_payment_types')
        .create(conceptPaymentType)
        .then(() => {
          swal({
            title: 'Listo!',
            text: 'El tipo de concepto de pago fue creado.',
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-success',
            type: 'success',
          }).then(() => this.$router.push({ name: 'ConceptPaymentTypesList' }));
        });
    },
  },
};
</script>
